import {PayloadAction, createSlice} from '@reduxjs/toolkit'
import {
  TypeExamState,
  FetchTypeExamsResponse,
  FetchTypeExamByIdResponse,
  FetchAllTypeExamsResponse,
} from './types'
import {
  fetchTypeExamById,
  fetchTypeExams,
  createTypeExam,
  updateTypeExam,
  deleteTypeExam,
  suspendTypeExam,
  activateTypeExam,
  fetchAllTypeExams,
} from './service'
import {ResponseError} from '../commonTypes'

const initialState: TypeExamState = {
  typeExamForEdit: null,
  typeExams: [],
  total: 0,
  totalPages: 0,
  listLoading: false,
  actionLoading: false,
  error: null,
}
const typeExamSlice = createSlice({
  name: 'typeExam',
  initialState,
  reducers: {
    resetTypeExams: (state: TypeExamState) => {
      state.typeExams = []
      state.total = 0
      state.totalPages = 0
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchTypeExams.pending, (state: TypeExamState) => {
      state.listLoading = true
      state.error = null
    })
    builder.addCase(fetchTypeExams.rejected, (state: TypeExamState, action: PayloadAction<any>) => {
      const {error} = action.payload
      state.error = error
      state.listLoading = false
    })
    builder.addCase(
      fetchTypeExams.fulfilled,
      (state: TypeExamState, action: PayloadAction<FetchTypeExamsResponse>) => {
        state.listLoading = false
        state.error = null
        const {typeExams, total, totalPages} = action.payload
        state.typeExams = typeExams
        state.total = total
        state.totalPages = totalPages
      }
    )

    builder.addCase(fetchAllTypeExams.pending, (state: TypeExamState) => {
      state.listLoading = true
      state.error = null
    })
    builder.addCase(
      fetchAllTypeExams.rejected,
      (state: TypeExamState, action: PayloadAction<any>) => {
        const {error} = action.payload
        state.error = error
        state.listLoading = false
      }
    )
    builder.addCase(
      fetchAllTypeExams.fulfilled,
      (state: TypeExamState, action: PayloadAction<FetchAllTypeExamsResponse>) => {
        state.listLoading = false
        state.error = null
        const {typeExams} = action.payload
        state.typeExams = typeExams
      }
    )

    builder.addCase(fetchTypeExamById.pending, (state: TypeExamState) => {
      state.listLoading = true
      state.error = null
    })
    builder.addCase(
      fetchTypeExamById.rejected,
      (state: TypeExamState, action: PayloadAction<any>) => {
        const {error} = action.payload
        state.error = error
        state.listLoading = false
      }
    )
    builder.addCase(
      fetchTypeExamById.fulfilled,
      (state: TypeExamState, action: PayloadAction<FetchTypeExamByIdResponse>) => {
        state.typeExamForEdit = action.payload.typeExam
        state.listLoading = false
        state.error = null
        state.typeExamForEdit = action.payload.typeExam
      }
    )

    builder.addCase(createTypeExam.pending, (state: TypeExamState) => {
      state.actionLoading = true
      state.error = null
    })
    builder.addCase(createTypeExam.rejected, (state: TypeExamState, action: PayloadAction<any>) => {
      const {error} = action.payload
      state.error = error
      state.actionLoading = false
    })
    builder.addCase(
      createTypeExam.fulfilled,
      (state: TypeExamState, action: PayloadAction<FetchTypeExamByIdResponse>) => {
        state.typeExamForEdit = action.payload.typeExam
        state.actionLoading = false
        state.error = null
      }
    )

    builder.addCase(updateTypeExam.pending, (state: TypeExamState) => {
      state.actionLoading = true
      state.error = null
    })
    builder.addCase(updateTypeExam.rejected, (state: TypeExamState, action: PayloadAction<any>) => {
      const {error} = action.payload
      state.error = error
      state.actionLoading = false
    })
    builder.addCase(
      updateTypeExam.fulfilled,
      (state: TypeExamState, action: PayloadAction<FetchTypeExamByIdResponse>) => {
        state.typeExamForEdit = action.payload.typeExam
        state.actionLoading = false
        state.error = null
      }
    )

    builder.addCase(deleteTypeExam.pending, (state: TypeExamState) => {
      state.actionLoading = true
      state.error = null
    })
    builder.addCase(deleteTypeExam.rejected, (state: TypeExamState, action: PayloadAction<any>) => {
      const {error} = action.payload
      state.error = error
      state.actionLoading = false
    })
    builder.addCase(
      deleteTypeExam.fulfilled,
      (state: TypeExamState, action: PayloadAction<FetchTypeExamByIdResponse>) => {
        state.typeExamForEdit = action.payload.typeExam
        state.actionLoading = false
        state.error = null
      }
    )

    builder.addCase(suspendTypeExam.pending, (state: TypeExamState) => {
      state.actionLoading = true
      state.error = null
    })
    builder.addCase(
      suspendTypeExam.rejected,
      (state: TypeExamState, action: PayloadAction<any>) => {
        const {error} = action.payload
        state.error = error
        state.actionLoading = false
      }
    )
    builder.addCase(
      suspendTypeExam.fulfilled,
      (state: TypeExamState, action: PayloadAction<FetchTypeExamByIdResponse>) => {
        state.typeExamForEdit = action.payload.typeExam
        state.actionLoading = false
        state.error = null
      }
    )

    builder.addCase(activateTypeExam.pending, (state: TypeExamState) => {
      state.actionLoading = true
      state.error = null
    })
    builder.addCase(
      activateTypeExam.rejected,
      (state: TypeExamState, action: PayloadAction<any>) => {
        const {error} = action.payload
        state.error = error
        state.actionLoading = false
      }
    )
    builder.addCase(
      activateTypeExam.fulfilled,
      (state: TypeExamState, action: PayloadAction<FetchTypeExamByIdResponse>) => {
        state.typeExamForEdit = action.payload.typeExam
        state.actionLoading = false
        state.error = null
      }
    )
  },
})

export default typeExamSlice.reducer
export const actions = typeExamSlice.actions
